<template>
  <generic-triangle
    :type="polygonalChartType"
    :data="data"
    :alarmed="alarmed"
    :coordinates="triangleCoordinates"
  ></generic-triangle>
</template>
<script>
import polygonalChartTypes from '@/domain/enums/polygonalCharts/polygonalChart';
import duvalTriangleCoordinates from '@/domain/services/installation/engineering/chromatography/duvalTriangleCoordinates';
import GenericTriangle from './GenericTriangle';

export default {
  components: {
    GenericTriangle,
  },
  props: {
    data: {
      default: () => ({}),
    },
    alarmed: Boolean,
  },
  data: () => ({
    polygonalChartType: polygonalChartTypes.DUVAL_TRIANGLE_4,
  }),
  computed: {
    triangleCoordinates() {
      return duvalTriangleCoordinates
        .getTriangle4Coordinates(this.data);
    },
  },
};
</script>
